import { render, staticRenderFns } from "./lole-size.vue?vue&type=template&id=05cc5fb4&scoped=true&"
import script from "./lole-size.vue?vue&type=script&lang=js&"
export * from "./lole-size.vue?vue&type=script&lang=js&"
import style0 from "./lole-size.vue?vue&type=style&index=0&id=05cc5fb4&prod&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cc5fb4",
  null
  
)

export default component.exports